var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{'btn_small': _vm.small, 'btn_block': _vm.block},style:({color: _vm.customColor}),attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('div',{staticClass:"btn__item"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }